import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "ac-app-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "ac-route-progress"
}
const _hoisted_4 = {
  key: 2,
  class: "ac-navbar"
}
const _hoisted_5 = { class: "ac-navbar__inner" }
const _hoisted_6 = { class: "ac-nav" }
const _hoisted_7 = { class: "ac-nav__icon" }
const _hoisted_8 = { class: "ac-navbar__clock" }
const _hoisted_9 = {
  id: "main-body",
  class: "ac-main"
}
const _hoisted_10 = { class: "ac-footer" }

import { ref, watch, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Card, Cursor, Footer, Loading, NotificationContainer, Progress, Time } from 'animal-island-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const shouldShowNavbar = ref(false)

/** 首屏加载遮罩显隐（初始 true，路由就绪后延迟淡出以展示动森岛屿动画） */
const appLoading = ref(true)
/** 路由切换进度条显隐 */
const routeLoading = ref(false)
/** 路由切换进度条当前百分比（0-100） */
const routeProgress = ref(0)
/** 路由进度条模拟推进定时器句柄 */
let progressTimer: number | undefined

/** 导航菜单项配置 */
const navItems = [
  { path: '/', label: 'HOME', icon: '🏠' },
  { path: '/self_setting', label: 'SETTING', icon: '⚙️' },
  { path: '/blog', label: 'BLOG', icon: '📖' },
  { path: '/calendar', label: 'CALENDAR', icon: '📅' },
  { path: '/pomodoro', label: 'TOMATO', icon: '🍅' },
]

/**
 * 函数功能：根据登录状态与路由元信息控制导航栏显隐
 * 输入参数：无
 * 输出参数：无（更新 shouldShowNavbar 响应式变量）
 * 返回值：无
 */
function checkLoginStatus(): void {
  const loginStatusString = localStorage.getItem('honey-user')
  let isLoggedIn = false

  if (loginStatusString) {
    try {
      const userData = JSON.parse(loginStatusString)
      if (userData && Object.keys(userData).length > 0) {
        isLoggedIn = true
      }
    } catch (e) {
      isLoggedIn = false
    }
  }

  shouldShowNavbar.value = !!(isLoggedIn && route.meta.showNavbar)
}

// 路由变化时重新检查登录状态与导航栏显隐
watch(
  () => route.fullPath,
  () => checkLoginStatus(),
  { immediate: true }
)

// 修复：直接访问/刷新 "/" 时导航栏不显示——
// immediate 的 watch 在路由初始导航完成前执行，此时 route 还是 START_LOCATION
// （meta 为空对象），而初始导航完成后 fullPath 仍为 "/"（值未变化）不会再次触发
// watch；router.isReady() 在初始导航真正完成后 resolve，此时重查一次确保导航栏显示。
// 同时在初始路由就绪后关闭首屏 Loading 遮罩（保留短暂动画时间）
router.isReady().then(() => {
  checkLoginStatus()
  window.setTimeout(() => {
    appLoading.value = false
  }, 500)
})

// 路由跳转开始：显示顶部条纹进度条并模拟推进（懒加载页面时给出加载反馈）
router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    routeLoading.value = true
    routeProgress.value = 8
    if (progressTimer !== undefined) window.clearInterval(progressTimer)
    progressTimer = window.setInterval(() => {
      // 模拟推进：上限 85%，完成时机交给 afterEach
      if (routeProgress.value < 85) {
        routeProgress.value = Math.min(85, routeProgress.value + 7)
      }
    }, 120)
  }
  next()
})

// 路由跳转完成：进度条冲到 100% 后收起
router.afterEach(() => {
  if (progressTimer !== undefined) {
    window.clearInterval(progressTimer)
    progressTimer = undefined
  }
  if (routeLoading.value) {
    routeProgress.value = 100
    window.setTimeout(() => {
      routeLoading.value = false
    }, 350)
  }
})

// 组件卸载时清理定时器
onBeforeUnmount(() => {
  if (progressTimer !== undefined) window.clearInterval(progressTimer)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(Cursor), { "force-all": false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (appLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Loading), { active: true })
            ]))
          : _createCommentVNode("", true),
        (routeLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(Progress), {
                percent: routeProgress.value,
                "show-info": false,
                size: "small",
                duration: 0.15
              }, null, 8, ["percent"])
            ]))
          : _createCommentVNode("", true),
        (shouldShowNavbar.value)
          ? (_openBlock(), _createElementBlock("header", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "ac-navbar__brand"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("span", { class: "ac-navbar__leaf" }, "🏝️", -1),
                    _createElementVNode("span", { class: "ac-navbar__title" }, "Valinor", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("nav", _hoisted_6, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                    return _createVNode(_component_router_link, {
                      key: item.path,
                      to: item.path,
                      class: _normalizeClass(["ac-nav__item", { 'is-active': _unref(route).path === item.path }])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.icon), 1),
                        _createElementVNode("span", null, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"])
                  }), 64))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(Time))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("main", _hoisted_9, [
          _createVNode(_component_router_view)
        ]),
        _createElementVNode("footer", _hoisted_10, [
          _createVNode(_unref(Card), { class: "ac-footer__card" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "ac-footer__grid" }, [
                _createElementVNode("div", { class: "ac-footer__col" }, [
                  _createElementVNode("h4", { class: "ac-footer__head" }, "🏝 About Me"),
                  _createElementVNode("p", { class: "ac-footer__text" }, " Comrade Pancrase Dai is a communist who did not join the party, he loves to play basketball, usually the third and fourth positions, but his throwing skills are not good, he loves to watch some anime, he dreamed of being a writer when he was a child, and when he grew up, he was slow to react and liked to play games. ")
                ]),
                _createElementVNode("div", { class: "ac-footer__col" }, [
                  _createElementVNode("h4", { class: "ac-footer__head" }, "🔗 Quick Links"),
                  _createElementVNode("div", { class: "ac-footer__link" }, [
                    _createElementVNode("a", {
                      href: "https://space.bilibili.com/32435693",
                      target: "_blank"
                    }, "📺 My Bilibili")
                  ]),
                  _createElementVNode("div", { class: "ac-footer__link" }, [
                    _createElementVNode("a", {
                      href: "https://weibo.com/u/5316518027",
                      target: "_blank"
                    }, "💭 My Weibo")
                  ])
                ]),
                _createElementVNode("div", { class: "ac-footer__col" }, [
                  _createElementVNode("h4", { class: "ac-footer__head" }, "✉️ Contact Me"),
                  _createElementVNode("p", { class: "ac-footer__text" }, "📞 +86 13833988217"),
                  _createElementVNode("p", { class: "ac-footer__text" }, "📱 +86 18920255540"),
                  _createElementVNode("p", { class: "ac-footer__text" }, "📮 651370869@qq.com")
                ])
              ], -1),
              _createElementVNode("div", { class: "ac-footer__copy" }, "Copyright © 2023 PancraseDai's Personal Website. All Rights Reserved.", -1),
              _createElementVNode("div", { class: "ac-footer__beian" }, [
                _createTextVNode(" 备案号："),
                _createElementVNode("a", {
                  href: "https://beian.miit.gov.cn/",
                  target: "_blank"
                }, "冀ICP备2024065561号-1")
              ], -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(Footer), { type: "sea" })
        ]),
        _createVNode(_unref(NotificationContainer))
      ])
    ]),
    _: 1
  }))
}
}

})